export default __webpack_public_path__ + "static/biggap-9a0135d00aea39bc46405036703d7dbf.png";